<section class="p-3">

  <lib-dialog-header
    [titulok]="'Kontrola prerekvizít' | translate"
    [predmetNazov]="data.znamka.predmetNazov"
    [predmetSkratka]="data.znamka.predmetSkratka">
  </lib-dialog-header>

  <mat-dialog-content class="mat-typograph p-0">

    <div>
      <div *ngIf="prerekvizita.vyrazNaVypis === null; else vyrazNaVypisIsNotNull">
        <h3 i18n>Predmet nemá žiadne prerekvizity.</h3>
      </div>
      <ng-template #vyrazNaVypisIsNotNull>
        <div *ngIf="prerekvizita.splnena === null" i18n>Prezekvizity nie sú vyhodnotiteľné</div>
        <div *ngIf="prerekvizita.splnena === true" class="alert alert-success" i18n>Prerekvizity sú splnené</div>
        <div *ngIf="prerekvizita.splnena === false" class="alert alert-danger" i18n>Prerekvizity nie sú splnené</div>
        <h3 class="text-center" innerHTML="{{prerekvizita.vyrazNaVypis}}"></h3>
      </ng-template>
    </div>

    <hr/>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
